module.exports = __webpack_public_path__ + "img/homestyleChicken.46dfb17f.png";